"use client";

import { Toaster as Sonner, ToasterProps } from "sonner";

/**
 * Sonner ships light and dark palettes of its own and, on `theme="system"`,
 * picks between them from `prefers-color-scheme` alone. None of our apps mount
 * a theme provider — they follow our tokens, which only turn dark under a
 * `.dark` class — so on a device set to dark mode Sonner painted its dark
 * palette onto a light toast, leaving the description near-white on white. Pin
 * it to the light baseline and let our tokens do the theming; `globals.css`
 * maps the one colour Sonner hard-codes rather than reading from a variable.
 */
const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
